import { Container } from "aurelia-dependency-injection";
import { defineComponent, PropType } from "vue";

import { PatientService } from "../../../../../../services/patient.service";
import { IResolvedProblems } from "../../../../../../resources-vue/vue-interfaces/i-patient";
import { LookupService } from "../../../../../../services/lookup-service";
import { formatDate, formatDateInput } from "../../../../../../common/vue-helpers/modifiers/value-modifier";
import { IPageCallbackResult } from "../../../../../../resources-vue/vue-interfaces/i-page-container";

import Pagination from "../../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";
import TableEmpty from "../../../../../../resources-vue/vue-custom-elements/TableEmpty/TableEmpty.vue";
import ProblemsRow from "../ProblemsRow/ProblemsRow.vue";

export default defineComponent({
    components: {
        Pagination,
        TableEmpty,
        ProblemsRow
    },

    props: {
        problems: {
            type: Array as PropType<IResolvedProblems[]>,
            default: null
        }
    },

    data() {
        return {
            isAddRequested: true as boolean,
            columns: 4 as number,
            paginationInstance: null as typeof Pagination,
            currentPage: 1 as number,
            currentPageItems: [] as IResolvedProblems[],
            pageLimit: 5 as number,
            isLoading: false as boolean,
            newProblems: [] as IResolvedProblems[],
            _patientsService: null as PatientService,
            _lookupService: null as LookupService,
            formatDateInput,
            formatDate
        };
    },

    emits: ["update:problems"],

    created() {
        this._patientsService = Container.instance.get(PatientService);
        this._lookupService = Container.instance.get(LookupService);
        this.paginationInstance = this.$refs.paginationInstance;
    },

    mounted() {
        this.paginationInstance = this.$refs.paginationInstance;
        this.paginationInstance.reset();
    },

    methods: {
        addProblem() {
            this.newProblems.push({
                code: "",
                description: "",
                startDate: null,
                resolvedDate: null,
                resolvedOrder: null,
                isResolvedDateUnknown: false,
                isStartDateUnknown: false
            });
            this.isAddRequested = true;
        },

        saveNewProblem(index: number) {
            let arr = [...this.problems];
            this.newProblems[index].resolvedOrder = this.problems.length + 1;
            arr.push(this.newProblems[index]);
            this.newProblems = [];
            this.$emit("update:problems", [...arr]);
        },

        cancelSaveNewProblem(index: number) {
            this.newProblems.splice(index, 1);
        },

        moveProblem(oldIndex: number, newIndex: number) {
            let arr = [...this.problems];
            if (oldIndex >= arr.length || oldIndex < 0) {
                return;
            }
            if (newIndex >= arr.length || newIndex < 0) {
                return;
            }
            arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
            arr = arr.map((problem: IResolvedProblems, index) => {
                problem.resolvedOrder = index + 1;
                return problem;
            });
            this.$emit("update:problems", arr);
        },

        async pageChangedCallback(pageNumber: number): Promise<IPageCallbackResult> {
            this.currentPage = pageNumber;
            if (this.problems?.length > 0) {
                let endIndex = this.pageLimit * this.currentPage;
                let startIndex = endIndex - this.pageLimit;
                if (endIndex > this.problems.length) {
                    endIndex = this.problems.length;
                }
                if (startIndex < 0) {
                    startIndex = 0;
                }
                this.currentPageItems = this.problems.slice(startIndex, endIndex);
            } else {
                this.currentPageItems = [];
            }
            if (this.currentPageItems.length === 0 && this.problems.length > 0) {
                this.paginationInstance.decrementPageNumber();
            }
            return {
                totalPageCount: this.problems.length < this.pageLimit ? 1 : Math.ceil(this.problems.length),
                success: true,
                totalCount: this.problems.length
            };
        },

        deleteProblem(index: number) {
            if (this.problems.length >= 1) {
                this.problems.splice(index, 1);
                this.$emit(
                    "update:problems",
                    this.problems.map((problem: IResolvedProblems, probIdx) => {
                        problem.resolvedOrder = probIdx + 1;
                        return problem;
                    })
                );
            }
            this.paginationInstance?.reset();
        },
        cancelEditProblemChanges(oldProblem: IResolvedProblems, index: number) {
            const temp = this.problems.map((problem: IResolvedProblems, probIdx) => {
                if (probIdx === index) {
                    return oldProblem;
                } else {
                    return problem;
                }
            });
            this.$emit("update:problems", temp);
        }
    }
});
